// src/RequireAuth.jsx
import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthProvider";

export default function RequireAuth() {
  const { account, isLoading } = useContext(AuthContext);
  const location = useLocation();

  // Mostrar spinner mientras se verifica la autenticación
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <svg className="h-12 w-12 animate-spin mx-auto text-blue-600" viewBox="0 0 24 24" fill="none">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <p className="mt-4 text-gray-600 font-medium">Verificando acceso...</p>
        </div>
      </div>
    );
  }

  // Si no hay cuenta autenticada, redirigir al login
  if (!account) {
    // console.log('[RequireAuth] Usuario no autenticado, redirigiendo a login');
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // console.log('[RequireAuth] Usuario autenticado:', account.username);
  // Usuario autenticado: renderizar las rutas protegidas
  return <Outlet />;
}
